import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./rotateMe.scss";

export const RotateMe = () => {
    return (<>
        <div className="rotate-me">
            <FontAwesomeIcon icon="tablet-alt" size="2x" className='svg-standard-color'></FontAwesomeIcon>
        </div>
        <br className='rotate-me-helper-newline' />
        <br className='rotate-me-helper-newline' />
    </>)
}


